import { ArrowBackIcon } from "@chakra-ui/icons";
import { IconButton } from "@chakra-ui/react";
import React from "react";
import Colors from "../../../assets/colors/Colors";

const BackIconButton = props => {
    if (props.iconButton) {
        return (
            <IconButton
                bg={Colors.posTextAreaBackground}
                mb="0.88rem"
                borderRadius="1.5rem"
                onClick={props.onClick}
                height="1.88rem"
                minW="1.88rem"
                variant="posghost"
                icon={
                    <ArrowBackIcon
                        color={Colors.posTextInfo}
                        boxSize="0.95rem"
                    />
                }
            />
        );
    }
};

export default BackIconButton;
